import { API } from "config";
import { getUserJWT } from "functions/jwt";
import axios from "axios";

const RestAuthService = {};

RestAuthService.signInEmailRequest = async (email, password) => {
    let user = { email, password };
    let data = await axios
        .post(`${API}/user/signin`, user)
        .then((response) => response.data)
        .catch((err) => err);
    return data;
};

// await auth.signInWithEmailAndPassword(email, password).then(user => user).catch(err => err);

RestAuthService.signOutRequest = async () => {
    let logout = false;
    var URL = `${API}/user/signout`;
    axios.defaults.withCredentials = true;
    logout = await axios
        .get(URL, getUserJWT())
        .then((response) => response.data)
        .catch((err) => err);
    if (logout.message) {
        return logout;
    }
};

RestAuthService.singUpRequest = async (user) => {
    let data = await axios
        .post(`${API}/user/signup`, user)
        .then((response) => response.data)
        .catch((err) => err);

    // data.message = "";
    // if (data.error === undefined || data.error) {
    //     data.message = "Signup process was failed";
    //     data.showMessage = true;
    // } else {
    //     data.message = "";
    // }

    return data;
};

export default RestAuthService;
